module.exports = __webpack_public_path__ + "img/medlabo_banner.3c702a8b.png";